import classNames from "classnames";
import { NavigationModel } from "models/NavigationModel";
import { useState } from "react";

import { HeaderDropdownItem } from "./HeaderDropdownItem";
import { HeaderMenuDropdown } from "./HeaderMenuDropdown";

interface HeaderNavDropdownProps {
  className?: string;
  item: NavigationModel;
  children?: (NavigationModel | null)[];
}

export const HeaderNavDropdown: React.FC<HeaderNavDropdownProps> = ({ className, item, children = [] }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { iconStart, text, isSelected } = item;

  const trigger = (
    <>
      {iconStart ? <div className="sbb-header-nav-item-icon me-2">{iconStart}</div> : null}
      {text}
      <div className="sbb-header-nav-item-icon ms-2">
        <i className="ms-Icon ms-Icon--ChevronDown" />
      </div>
    </>
  );

  const buttonClassName = classNames(className, isSelected ? "active" : "");

  return (
    <HeaderMenuDropdown
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      trigger={trigger}
      buttonClassName={buttonClassName}
      id={text}
    >
      {children.map((child, i) =>
        child === null ? (
          <hr key={`sep-${i}`} className="dropdown-divider" />
        ) : (
          <HeaderDropdownItem key={`dropdown-item-${i}`} item={child} />
        )
      )}
    </HeaderMenuDropdown>
  );
};
